/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { CompanyModel } from '../entities/CompanyModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { cityModelSchema } from './cityModelSchema'
import { domainCompanyRewardTypeStringSchema } from './domain/companyRewardTypeStringSchema'
import { z } from 'zod'

export const companyModelSchema = z.object({
  cities: z.array(z.lazy(() => cityModelSchema)),
  id: z.string(),
  inn: z.string(),
  kpp: z.string().optional(),
  legal_address: z.string(),
  legal_name: z.string(),
  name: z.string(),
  ogrn: z.string(),
  reward_type: z.lazy(() => domainCompanyRewardTypeStringSchema),
}) as unknown as ToZod<CompanyModel>